import React, {useState, useEffect, useRef} from 'react';
import { 
    SelectContainerV2, 
    Label, 
    Arrow, 
    Clearabled, 
    Plus,
    Legenda, 
    Options, 
    Option, 
    NoOptions, 
    YesNoContainer, 
    YesNoContainerMobile,
    Loading,
    ContainerTextFronSelectedCard,
    ContainerTextFronSelectedCardContent
} from './styles_v2_multi_header';
import ArrowIcon from "../../assets/icons/icon-arrow.svg";
import DeleteIcon from "../../assets/icons/icon-close-without-circle-gray.png";
import Interruptor from '../interruptor';
import ModalAlert from '../modal/modalGeneric';
import Button from '../button/button_v2';
import ButtonAddNew from '../buttonAddNew';
import Solicitar from '../../pages/solicitar';
import { store } from "react-notifications-component";
import IconHelp from '../../assets/icons/help';

// import ArrowDown from '../../assets/icons/icons8-expand-arrow-32.png';
import ArrowDown from '../../assets/icons/icon-arrow-down-circle-gray.png';

import api from '../../services/api';
import { TaglineM, TaglineMSpan, TaglineP } from '../../styles/stylesTypography';
import { theme } from '../../styles/theme';

export const USER = "@userinfo";

const SelectV2MultiHeaderFarm = ({ onMenuScrollToBottom, ...props }) => {
    const [ref] = useState(useRef());
    const [isOpen, setIsOpen] = useState(false);
    const [value, setValue] = useState('');

    useEffect(() => {
        if (props.value && typeof props.value === 'object') {
            setValue(props.value);
        } else if (!props.value) {
            setValue('');
        }
    }, [props.value]);
    const [selectOptions, setSelectOptions] = useState([]);
    const [yesNoValue, setYesNoValue] = useState(true);

    const [solicitaP, setSolicitaP] = useState(false);
    const [showModalSolicitar, setModalSolicitar] = useState(false);
    const [showModalBlock, setModalBlock] = useState(false);

    const [addOptions, setAddOptions] = useState(false);
    const [limit, setLimit] = useState(20);
    const [dropdownSearchTerm, setDropdownSearchTerm] = useState('');
    const [dropdownFilteredOptions, setDropdownFilteredOptions] = useState([]);

    const [isclose, setisclose] = useState(false);

    const optionsRef = useRef(null);

    const onChange = (valueOp) => {
           
        if (value) {
            if (value.value !== valueOp.value) {
                if (props.isSearch === true) {
                    if (valueOp.value != props.value) {
                        props.onChange(valueOp);
                        setValue(valueOp);
                        setIsOpen(false);
                    } else {
                        setValue(valueOp);
                    }
                } else {
                    props.onChange(valueOp);
                    setValue(valueOp);
                    setIsOpen(false);
                    setDropdownSearchTerm('');
                }
            }
        } else {
            if (props.isSearch === true) {
                if (valueOp.value != props.value) {
                    props.onChange(valueOp);
                    setValue(valueOp);
                    setIsOpen(false);
                } else {
                    setValue(valueOp);
                }
            } else {
                props.onChange(valueOp);
                setValue(valueOp);
                setIsOpen(false);
                setDropdownSearchTerm('');
            }
        }
    }

    const normalizeText = (text) => {
        if (!text) return '';
        return text
            .toString()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase();
    };

    const filterOptionsByQuery = (options = [], query = '') => {
        const normalizedQuery = normalizeText(query).trim();
        if (!normalizedQuery) return options;

        return options.filter((option) => {
            const normalizedLabel = normalizeText(option?.label || '');
            const doc = (option?.cpf_cnpj || option?.documento || '').toString().replace(/[^\d]/g, '');
            const queryDoc = normalizedQuery.replace(/[^\d]/g, '');
            const matchLabel = normalizedLabel.includes(normalizedQuery);
            const matchDoc = queryDoc ? doc.includes(queryDoc) : false;
            return matchLabel || matchDoc;
        });
    };

    const getFarmDisplayData = (option) => {
        if (!option) {
            return {
                farmName: '',
                producerName: '',
                document: '',
            };
        }

        const rawLabel = (option.label || '').toString();
        const nomeFazenda = option.nomeFazenda || rawLabel.split(' - ')[0] || '';
        const producerName = option.produtor?.nome || option.producerName || '';
        const document = option.documento || option.cpf_cnpj || '';

        return {
            farmName: nomeFazenda.toUpperCase(),
            producerName: producerName.toUpperCase(),
            document: formatCpfCnpj(document),
        };
    };

    const formatCpfCnpj = (value) => {
        if (!value) return "";

        const cleaned = value.toString().replace(/\D/g, "");

        if (cleaned.length <= 11) {
            if (cleaned.length <= 3) return cleaned;
            if (cleaned.length <= 6) return `${cleaned.slice(0, 3)}.${cleaned.slice(3)}`;
            if (cleaned.length <= 9) return `${cleaned.slice(0, 3)}.${cleaned.slice(3, 6)}.${cleaned.slice(6)}`;
            return `${cleaned.slice(0, 3)}.${cleaned.slice(3, 6)}.${cleaned.slice(6, 9)}-${cleaned.slice(9)}`;
        }

        if (cleaned.length <= 2) return cleaned;
        if (cleaned.length <= 5) return `${cleaned.slice(0, 2)}.${cleaned.slice(2)}`;
        if (cleaned.length <= 8) return `${cleaned.slice(0, 2)}.${cleaned.slice(2, 5)}.${cleaned.slice(5)}`;
        if (cleaned.length <= 12) return `${cleaned.slice(0, 2)}.${cleaned.slice(2, 5)}.${cleaned.slice(5, 8)}/${cleaned.slice(8)}`;
        return `${cleaned.slice(0, 2)}.${cleaned.slice(2, 5)}.${cleaned.slice(5, 8)}/${cleaned.slice(8, 12)}-${cleaned.slice(12, 14)}`;
    };
    
    const formatProdutores = (produtores) => {
        produtores = produtores.map(produtor => {
            const format = {
                value: produtor.id || produtor.agro_producer_id,
                label: (produtor.nome || produtor.nome_produtor) + (produtor.cpf_cnpj ? ` - CPF/CNPJ: ${formatCpfCnpj(produtor.cpf_cnpj)}` : ''),
                cpf_cnpj: produtor.cpf_cnpj,
                estado: produtor.estado,
            };

            return format;
        });
        return produtores;
    };

    const changeInput = async (value) => {
        // Se já tiver um valor selecionado, não permite digitar
        if (value && value.value) {
            return;
        }

        setValue(value.target.value);

        let com_acento = "ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝŔÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿŕ-";
        let sem_acento = "AAAAAAACEEEEIIIIDNOOOOOOUUUUYRsBaaaaaaaceeeeiiiionoooooouuuuybyr ";

        let filterOptions;

        if(props.options[0].estado) {
            const payload = {
                search: value.target.value,
            }
            
            const response = await api.post(`/produtores/search/${props.options[0].estado}?limit=20&offset=0`, payload);

            
            const formatado = formatProdutores(response.data.data) 
    
            filterOptions = formatado;  
        }else{
            filterOptions = props.options;
        }


        filterOptions = filterOptions.filter(val => {
            let valLabel = val.label;
            let valCpfCnpj = val.cpf_cnpj;
            let valInput = value.target.value;

            let newValLabel = '';
            let newValInput = '';
            let newValCpfCnpj = '';

            // Formata o label (nome do produtor)
            if (valLabel) {
                for(let i=0; i<valLabel.length; i++) {
                    let troca=false;
                    for (let a=0; a<com_acento.length; a++) {
                        if (valLabel.substr(i,1)==com_acento.substr(a,1)) {
                            newValLabel+=sem_acento.substr(a,1);
                            troca=true;
                            break;
                        }
                    }
                    if (troca==false) {
                        newValLabel+=valLabel.substr(i,1);
                    }
                }
            }

            // Formata o valor digitado pelo usuário
            if (valInput) {
                for(let i=0; i<valInput.length; i++) {
                    let troca=false;
                    for (let a=0; a<com_acento.length; a++) {
                        if (valInput.substr(i,1)==com_acento.substr(a,1)) {
                            newValInput+=sem_acento.substr(a,1);
                            troca=true;
                            break;
                        } 
                    }
                    if (troca==false) {
                        newValInput+=valInput.substr(i,1);
                    }
                }
            }
            
            // Formata o CPF/CNPJ removendo pontos e traços
            if(valCpfCnpj){
                newValCpfCnpj = valCpfCnpj.replace(/[^\d]/g, '');
            }

            // Remove pontos e traços do valor digitado para comparar com CPF/CNPJ
            let inputSemPontuacao = valInput.replace(/[^\d]/g, '');

            // Verifica se o texto digitado corresponde ao nome OU ao CPF/CNPJ
            const matchNome = newValLabel && newValInput && 
                newValLabel.toLocaleLowerCase().includes(newValInput.toLocaleLowerCase());

            const matchCpfCnpj = newValCpfCnpj && inputSemPontuacao && 
                (newValCpfCnpj.includes(inputSemPontuacao) || 
                valCpfCnpj.includes(valInput));

            // Se não houver input, retorna true para mostrar todas as opções
            if (!valInput) {
                return true;
            }

            return matchNome || matchCpfCnpj;
        });
        
        setSelectOptions(filterOptions);
    }


    const close = (e) => {
        setTimeout(() => {
            setisclose(true);
        }, 300);
    }

    const selectByValue = (value) => {
        if (props.options.value) {
            if (props.options.value === value) {
                onChange(props.options);
            } else if (props.options.value === undefined && props.options.length > 0) {
                props.options.map((op) => {
                    if (op) {
                        if (op.value === value) {
                            onChange(op);
                        }
                    }
                })
            }
        } else {
            props.options.map((op) => {
                if (op) {
                    if (op.value === value) {
                        onChange(op);
                    }
                }
            })
        }
    }

    const solicitarProduto = () => {
        const user = JSON.parse(localStorage.getItem(USER));

        const functions = user.contrato.agro_plan_functions;
        functions.map((f) => {
            if (f.agro_plan_function_id === 7) {
                if ( f.status === 0) {
                    setModalBlock(true);
                } else {
                    setModalSolicitar(true);
                }
            }       
        });
    }

    const solicitarSucesso = () => {
        store.addNotification({
            title: "Sucesso!",
            message: `Produto solicitado com sucesso!`,
            type: "success",
            insert: "top",
            container: "top-right",
            animationIn: ["animated", "fadeIn"],
            animationOut: ["animated", "fadeOut"],
            dismiss: {
                duration: 4000,
                onScreen: true
            }
        });
        setModalSolicitar(false);
    }

    const clear = () => {
        if (value.value) {
            setValue('');
            setIsOpen(false);
            setDropdownSearchTerm('');
            props.onChange({value: '', label: '', cpf_cnpj: ''});
        } else if (typeof value === 'string') {
            setValue('');
            setIsOpen(false);
            setDropdownSearchTerm('');
            props.onChange({value: '', label: '', cpf_cnpj: ''});
            setSelectOptions(props.options)
        }
    }

    const clickArrow = () => {

        if (props.disabled === !true) {
            if (isOpen === true) {
                setIsOpen(false);
                setDropdownSearchTerm('');
            } else {
                setIsOpen(true);
                setDropdownSearchTerm('');
                if (ref.current && typeof ref.current.focus === 'function') {
                    ref.current.focus();
                }
            }
        } else if (!props.disabled) {
            if (isOpen === true) {
                setIsOpen(false);
                setDropdownSearchTerm('');
            } else {
                setIsOpen(true);
                setDropdownSearchTerm('');
                if (ref.current && typeof ref.current.focus === 'function') {
                    ref.current.focus();
                }
            }
        } else {
            
        }
    }

    const onFocusInput = () => {
        if (props.disabled === false || !props.disabled) {
            const inputElement = document.getElementById(props.id);
            if (inputElement && typeof inputElement.select === 'function') {
                inputElement.select();
            }
        }
    }

    const searchGoogleImages = (search) => {
        window.open(`https://www.google.com/search?q=${search}&sxsrf=ALiCzsY0y3LwsxgN0oeayW3_AJMzZFXcng:1657226469380&source=lnms&tbm=isch&sa=X&ved=2ahUKEwjV5ZPY0ef4AhWYpZUCHYKmDtAQ_AUoAXoECAIQAw&biw=1536&bih=792&dpr=1.25`, '_blank');
    }

    useEffect(() => {
        const handleScroll = () => {
          const el = optionsRef.current;
          if (el) {
            const isBottom = el.scrollHeight - el.scrollTop === el.clientHeight;
            if (isBottom && typeof onMenuScrollToBottom === 'function') {
              onMenuScrollToBottom();
            }
          }
        };
      
        const el = optionsRef.current;
        if (el) {
          el.addEventListener('scroll', handleScroll);
        }
      
        return () => {
          if (el) {
            el.removeEventListener('scroll', handleScroll);
          }
        };
      }, [onMenuScrollToBottom]);

    useEffect(() => {
        if (props.options) {
            setSelectOptions(props.options);
            
            if (props.options.length === 0) {
                setValue('');
            }
        }
        
        if (props.value != 0 && props.value != undefined && props.value != '') {
            if (props.selectUniqueOption === true) {
                selectByValue(props.value);
            }
        }

        if (props.value || props.value === 0) {
            selectByValue(props.value);
        } else if (props.value === '') {
            setValue('');
        }
    },[props.options, props.value, props.selectUniqueOption]);

    const showDropdownSearch = props.enableDropdownSearch || props.formatFarmDisplay;

    useEffect(() => {
        if (showDropdownSearch) {
            setDropdownFilteredOptions(filterOptionsByQuery(selectOptions, dropdownSearchTerm));
        } else {
            setDropdownFilteredOptions(selectOptions);
        }
    }, [showDropdownSearch, selectOptions, dropdownSearchTerm]);

    useEffect(() => {
        if (selectOptions.length > 0) {
            if (selectOptions.length == 1) {
                if (value) {
                    if (selectOptions[0]) {
                        if (value.value != selectOptions[0].value) {
                            if (props.selectUniqueOption === true) {
                                onChange(selectOptions[0]);
                            }
                        }
                    }
                } else {
                    if (selectOptions[0]) {
                        if (selectOptions[0].value) {
                            if (props.selectUniqueOption === true) {
                                onChange(selectOptions[0]);
                            }
                        }
                    }
                }
            }
            setSolicitaP(false)
        }else{
            setSolicitaP(true)
        }

        if (selectOptions.value) {
            if (selectOptions[0] === undefined) {
                setSelectOptions([selectOptions]);
            }
        }
    },[selectOptions]);

    useEffect(() => {
        if (props.yesNo === true) {
            props.onChangeYesNo(yesNoValue);
        }
    },[yesNoValue]);

    useEffect(() => {
        setYesNoValue(props.yesNoValue);
    },[props.yesNoValue])

    useEffect(() => {
        if (props.isOpen) {
            props.isOpen(isOpen);
        }

        if (isOpen) {
            setLimit(20);
        }
    }, [isOpen])

    useEffect(() => {

        if (isclose) {
            if (value && selectOptions.length === 0) {
                // setValue('');
                // clear();
            } else {
                if (value) {
                    if (selectOptions.length > 1) {
                        if (value.label) {
                            let save = '';
                            selectOptions.map((so) => {
                                if (so.label === value.label) {
                                    save = so;
                                }
                            });
        
                            if (save !== '') {
                                onChange(save);
                            } else {
                                // setValue('');
                                // clear();
                            }
                        } else {
                            setValue('');
                            clear();
                        }
                    } else {
                        if (value.label) {
                            let save = '';
                            selectOptions.map((so) => {
                                if (so.label === value.label) {
                                    save = so;
                                }
                            });
        
                            if (save !== '') {
                                onChange(save);
                            } else {
                                setValue('');
                                clear();
                            }
                        } else {
                            let save = '';
                            selectOptions.map((so) => {
                                if (so.label === value) {
                                    save = so;
                                }
                            });
        
                            if (save !== '') {
                                onChange(save);
                            } else {
                                setValue('');
                                clear();
                            }
                        }
                    }
                } else {
                    if (props.estado && props.estado.value === "SP") {
                        if (selectOptions.length === 1) {
                            return;
                        }
                    } else {
                        if (selectOptions.length === 1) {
                            onChange(selectOptions[0]);
                        }
                    }
                }
            }
    
            setTimeout(() => {
                setIsOpen(false);
                setisclose(false)
            }, 300);
        }
    }, [isclose])

    useEffect(() => {
        if (addOptions) {
            let sum = limit + 20;

            if (sum <= selectOptions.length) {
                if (limit !== sum) {
                    setLimit(sum);
                }
            } else {
                if (limit !== selectOptions.length) {
                    setLimit(selectOptions.length);
                }
            }
            setTimeout(() => {
                setAddOptions(false);
            }, 500);
        }
    }, [addOptions]);

    const observer = new IntersectionObserver(
        ([entry]) => {
            if (entry.isIntersecting) {
                setAddOptions(true);
            }
        },
        {
            root: null,
            rootMargin: "0px",
            threshold: 0.1
        }
    );

    const element = document.querySelector('#loading-options')
    if (element) {
        observer.observe(element);
    }

    const optionsToRender = showDropdownSearch ? dropdownFilteredOptions : selectOptions;
    const hasNoFarms = !props.loading && Array.isArray(selectOptions) && selectOptions.length === 0;
    const showFarmSelectedCard = props.formatFarmDisplay && value && value.value && !props.optionSelected;
    const selectedFarmData = getFarmDisplayData(value);

    return (
        <SelectContainerV2 
            isOpen={isOpen} 
            erro={props.erro} 
            isModal={props.isModal} 
            disabled={props.disabled} 
            loading={props.loading} 
            yesNo={props.yesNo} 
            marginBottom={props.marginBottom}
            addNew={props.buttonAddNew}
            buttonDelete={props.buttonDelete}
            height={props.height}
            hasValue={value.value ? true : false}
        >
            <div className="container-Input" style={{
                    marginTop: props.buttonAddNew ? '-0px' : '0px',
                    position: 'relative',
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between',
            }}>
                {props.buttonDelete && (
                    <div 
                        className="clear-button" 
                        style={{
                            position: 'absolute',
                            right: '43px',
                            top: '48%',
                            transform: 'translateY(-50%)',
                            cursor: 'pointer',
                            zIndex: 2,
                        }}
                        onClick={() => {
                            setValue(''); 
                            if (props.onChange) {
                                props.onChange(''); 
                            }
                        }}
                    >
                        <img 
                            src={DeleteIcon} 
                            alt="Clear"
                            style={{
                                width: '10px',
                                height: '10px',
                            }}
                        />
                    </div>
                )}
                
                <div className='select'>
                    {props.label && (
                        <Label 
                            erro={props.erro} 
                            isFocus={isOpen}
                            existValue={value == '' ? false : true}
                            onClick={() => onFocusInput()}
                            isSearch={props.isSearch}
                            isDisabled={props.disabled}
                            buttonAddNew={props.buttonAddNew}
                            isYesNo={props.yesNo}
                            isModal={props.isModal}
                            labelWithAsterisk={props.labelWithAsterisk}
                        > 
                            {props.labelWithAsterisk && 
                                <b>*</b>}

                            {props.label || props.placeholder} 
                        </Label>
                    )}
                    
                    {props.yesNo === true ? (
                        <>
                        
                            {props.responsive ? (
                                <YesNoContainerMobile responsive={props.responsive} disabled={props.disabled} loading={props.loading}> <span>{props.messageYesNo}</span> <Interruptor value={yesNoValue} onChange={(e) => setYesNoValue(e)}/> </YesNoContainerMobile>

                            ) : (
                                <YesNoContainer 
                                    yesNoLeft={props.yesNoLeft} 
                                    showDisabled={props.showDisabledYesNo} 
                                    disabled={props.disabled} 
                                    loading={props.loading}
                                    // responsive={props.responsive}
                                > 
                                    <span style={{ marginRight: '5px' }}>
                                        {props.messageYesNo}
                                    </span> 
        
                                    <Interruptor 
                                        value={yesNoValue} 
                                        onChange={(e) => setYesNoValue(e)}
                                    /> 
                                </YesNoContainer>
                            )}
                        </>
                    ) : (null)}

                    {props.yesNo === true ? (
                        <YesNoContainerMobile disabled={props.disabled} loading={props.loading}> <span>{props.messageYesNo}</span> <Interruptor value={yesNoValue} onChange={(e) => setYesNoValue(e)}/> </YesNoContainerMobile>
                    ) : (null)}

                    {showFarmSelectedCard ? (
                        <ContainerTextFronSelectedCard
                            onClick={() => onFocusInput()}
                            isOpen={isOpen}
                            erro={props.erro}
                            isSearch={props.isSearch}
                            disabled={props.disabled}
                        >
                            <>
                                <TaglineMSpan>
                                    {selectedFarmData.farmName}
                                </TaglineMSpan>

                                <TaglineP> 
                                    {selectedFarmData.producerName} <br/>
                                    CPF/CNPJ: {selectedFarmData.document}
                                </TaglineP>
                            </>
                        </ContainerTextFronSelectedCard>
                    ) : props.loading ? (
                        <ContainerTextFronSelectedCard
                            onClick={() => null}
                            isOpen={isOpen}
                            erro={props.erro}
                            isSearch={props.isSearch}
                            disabled={props.disabled}
                        >
                            <TaglineMSpan>
                                Carregando...
                            </TaglineMSpan>
                        </ContainerTextFronSelectedCard>
                    ) : hasNoFarms ? (
                        <ContainerTextFronSelectedCard
                            onClick={() => null}
                            isOpen={isOpen}
                            erro={props.erro}
                            isSearch={props.isSearch}
                            disabled={props.disabled}
                        >
                            <ContainerTextFronSelectedCardContent hasNoFarms={hasNoFarms}>
                                <TaglineMSpan>
                                    Nenhuma fazenda encontrada
                                </TaglineMSpan>
                            </ContainerTextFronSelectedCardContent>
                        </ContainerTextFronSelectedCard>
                    ) : (
                        <ContainerTextFronSelectedCard
                            onClick={() => null}
                            isOpen={isOpen}
                            erro={props.erro}
                            isSearch={props.isSearch}
                            disabled={props.disabled}
                        >
                            <ContainerTextFronSelectedCardContent>
                                <TaglineMSpan>
                                    {selectedFarmData.farmName}
                                </TaglineMSpan>
                            </ContainerTextFronSelectedCardContent>
                        </ContainerTextFronSelectedCard>
                    )}
                </div>

                <div className='addnew'>
                    {props.buttonAddNew === true ? (
                        <ButtonAddNew responsive={props.responsive} isModal={props.isModal} onClick={() => props.onClickAddNew()} />
                    ) : (null)}
                    </div>
            </div>

            {props.loading === true ? (
                <>
                    <Loading 
                        addNew={props.buttonAddNew}
                    />
                </>
            ) : (
                <>
                    {props.disabled === true ? (null) : (
                        <>
                            {showFarmSelectedCard === "" ? null : (
                                <Arrow 
                                    yesNo={props.yesNo} 
                                    erro={props.erro} 
                                    isOpen={isOpen} 
                                    addNew={props.buttonAddNew}
                                    isClearable={props.isClearable} 
                                    disabled={props.disabled}
                                    onClick={() => clickArrow()}
                                >
                                    <img 
                                        className="arrow-select" 
                                        src={ArrowDown} 
                                        alt='arrow' 
                                        onClick={() => clickArrow()}
                                        style={{
                                            width: '20px',
                                            height: '20px',
                                        }}
                                    />
                                </Arrow>
                            )}
                
                            {
                                props.solicitar === true ? (
                                    <>
                                        {
                                            solicitaP === true ? (
                                                <Plus>
                                                    <p id="msg">Solicitar produto(s)</p>
                                                    <img 
                                                        className="add-select" 
                                                        src={DeleteIcon} 
                                                        alt='add'
                                                        onClick={() => solicitarProduto()}
                                                        width='12px'
                                                    />
                                                </Plus>
                                            ) : (
                                                <>
                                                    {
                                                        props.isClearable ? (
                                                            <Clearabled erro={props.erro} isOpen={isOpen} disabled={props.disabled}>
                                                                <img 
                                                                    className="delete-select" 
                                                                    src={DeleteIcon} 
                                                                    alt='delete'
                                                                    onClick={() => clear()}
                                                                    width='12px'
                                                                />
                                                            </Clearabled>
                                                        ) : (
                                                            null
                                                        )
                                                    }
                                                </>
                                            )
                                        }
                                    </>
                                ) : (
                                    <>
                                        {
                                            props.isClearable ? (
                                                <Clearabled erro={props.erro} isOpen={isOpen} disabled={props.disabled}>
                                                    <img 
                                                        className="delete-select" 
                                                        src={DeleteIcon} 
                                                        alt='delete'
                                                        onClick={() => clear()}
                                                        width='12px'
                                                    />
                                                </Clearabled>
                                            ) : (
                                                null
                                            )
                                        }
                                    </>
                                )
                            }
                        </>
                    )}
                </>
            )}

            {props.help === true ? (
                <div className="help-buttom" onClick={() => props.helpClick()}>
                    <IconHelp 
                        fill='#5DA8FD'
                        cursor='pointer'
                    />
                </div>
            ) : (null)}


            {isOpen && (
                <Options isOpen={isOpen} isSearch={props.isSearch} isClearable={props.isClearable} erro={props.erro} marginBottom={props.marginBottom} ref={optionsRef}>
                    <>
                        {showDropdownSearch && (
                            <div style={{ padding: '8px 12px', position: 'sticky', top: "-5px", backgroundColor: `${theme.colors.white.Branco}`, zIndex: 1 }}>
                                <input
                                    type='text'
                                    value={dropdownSearchTerm}
                                    placeholder={props.dropdownSearchPlaceholder || 'Buscar'}
                                    onChange={(e) => setDropdownSearchTerm(e.target.value)}
                                    style={{
                                        width: '100%',
                                        height: '36px',
                                        border: 'solid 1px #d9dfe8',
                                        borderRadius: '10px',
                                        padding: '0 12px',
                                        fontFamily: 'Lato',
                                        fontSize: '15px',
                                        color: '#303848',
                                        outline: 'none',
                                        backgroundColor: `${theme.colors.white.Branco}`,
                                    }}
                                />
                            </div>
                        )}
                        {optionsToRender.length > 0 ? (
                            <>
                                {optionsToRender.map((op, i) => (
                                    <>
                                        {op && i < limit && (
                                            <>
                                                <Option isSearch={props.isSearch} key={i} erro={props.erro} isMultiline={props.formatFarmDisplay} onClick={() => onChange(op)}>
                                                    {props.formatFarmDisplay ? (
                                                        <div style={{ width: '100%', display: 'flex', flexDirection: 'column'}}>
                                                            <TaglineMSpan>
                                                                {getFarmDisplayData(op).farmName}
                                                            </TaglineMSpan>

                                                            <TaglineP>
                                                                {getFarmDisplayData(op).producerName} <br/>
                                                                CPF/CNPJ: {getFarmDisplayData(op).document}
                                                            </TaglineP>
                                                        </div>
                                                    ) : op.label}

                                                    {op.produtor && (
                                                        <>
                                                        {/* {' '}- {op.produtor.nome} */}
                                                        </>
                                                    )}
                                                    
                                                    {op.label && props.searchPhoto ? (
                                                        <div
                                                            className="button-foto"
                                                            style={{
                                                                width: '90px',
                                                                minWidth: '90px',
                                                                display: 'flex',
                                                                flexDirection: 'row',
                                                                justifyContent: 'space-evenly',
                                                                alignItems: 'center',
                                                            }}
                                                            onClick={(e) => e.stopPropagation()}
                                                        >
                                                            <Button
                                                                width='90px'
                                                                value='Detalhes'
                                                                outline={true}
                                                                disabled={false}
                                                                onClick={() => props.onDossie ? props.onDossie(op) : searchGoogleImages(op.searchLabel || op.label)}
                                                                loading={false}
                                                            />
                                                        </div>
                                                    ) : (null)}
                                                </Option>

                                                {i === (limit-3) ? (
                                                    <div 
                                                        id='loading-options'
                                                    ></div>
                                                ) : (null)}
                                            </>
                                        )}

                                    </>     
                                ))}
                                
                            </>
                        ) : (
                            <NoOptions>
                                Não há resultados
                            </NoOptions>
                        )}
                    </>
                </Options>
            )}
            
            {props.erro && props.messageErro ? (
                <Legenda>{props.messageErro}</Legenda>
            ) : (<>
                {props.legenda && (
                    <Legenda>{props.legenda}</Legenda>
                )}
            </>)}

            <ModalAlert
                show={showModalSolicitar}
                onHide = {() => setModalSolicitar(false)}
                title="Solicitar Produto"
                size='lg'
            >
                <p style={{
                    width: '100%',
                    textAlign: 'center',
                    fontSize: '22px',
                    fontWeight: 'bold'
                }}>Solicitar um ou mais produto(s)</p>

                <Solicitar isModal={true} closeModalS={() => solicitarSucesso()}/>
            </ModalAlert>

            <ModalAlert
                show={showModalBlock}
                onHide = {() => setModalBlock(false)}
                title="Solicitar Produto"
            >
                <p style={{
                    fontFamily: 'Lato', 
                    fontSize: '22px', 
                    fontWeight: 'bold', 
                    fontStretch: 'normal', 
                    width: '100%', 
                    textAlign: 'center', 
                    alignSelf: 'center'
                }}>
                    Essa função não está liberada para o seu plano
                </p>

                <div 
                    style={{
                        color: '#303848', 
                        fontFamily: 'Lato', 
                        fontSize: '16px', 
                        fontWeight: 'normal', 
                        width: '100%', 
                        textAlign: 'center', 
                        alignSelf: 'center'
                    }}
                >
                    <p style={{
                        color: '#303848', 
                        fontFamily: 'Lato', 
                        fontSize: '16px', 
                        fontWeight: 'normal', 
                        width: '100%', 
                        textAlign: 'center', 
                        alignSelf: 'center'
                    }}> 
                        Faça um upgrade para desbloquear esse recurso
                    </p>

                    <div 
                        style={{ 
                            width: '100%', 
                            maxWidth: '350px', 
                            margin: 'auto',
                            marginTop: '20px', 
                            alignSelf: 'center', 
                            display: 'flex', 
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}
                    >
                        <Button
                            width='296px'
                            height='50px'
                            value='VER PLANOS'
                            outline={false}
                            disabled={false}
                            onClick={() => {
                                setModalBlock(false);
                                window.location = '/planos';
                            }}
                            loading={false}
                        />
                    </div>
                </div>
            </ModalAlert>
        </SelectContainerV2>
    );
}

export default SelectV2MultiHeaderFarm;
